<template>
  <div data-intro="Preencha ou edite os campos necessários." data-step="7" v-if="campaign">
    <AVista v-if="campaign.name === 'À VISTA'"/>
    <DePor v-if="campaign.name === 'DE POR'"/>
    <LeveMaisPagueMenos v-if="campaign.name === 'LEVE MAIS PAGUE MENOS'"/>
    <DescontoCategoria v-if="campaign.name === 'DESCONTO CATEGORIA'"/>
    <DadosDescontoPercentualSegundaUnidade v-if="campaign.name === 'DESCONTO NA 2ª UNIDADE'"/>
    <DePorUnitatioEmbalagem v-if="campaign.name === 'DE POR UNITÁRIO EMBALAGEM'"/>
    <LmpmCategoria v-if="campaign.name === 'LMPM CATEGORIA'"/>
  </div>
</template>

<script>
import DadosDescontoPercentualSegundaUnidade from "./rules/DadosDescontoPercentualSegundaUnidade.vue";
import AVista from "./rules/AVista.vue";
import DePor from "./rules/DePor.vue";
import LeveMaisPagueMenos from "./rules/LeveMaisPagueMenos.vue";
import DescontoCategoria from "./rules/DescontoCategoria.vue";
import LmpmCategoria from "./rules/LmpmCategoria.vue";
import DePorUnitatioEmbalagem from "./rules/DePorUnitatioEmbalagem.vue";

export default {
  components: {
    DePorUnitatioEmbalagem,
    LmpmCategoria,
    DescontoCategoria,
    LeveMaisPagueMenos,
    DePor,
    AVista,
    DadosDescontoPercentualSegundaUnidade
  },
  props: {
    onlineAccount: Object,
  },

  computed: {
    campaign() {
      if (this.$store.state.selector && this.$store.state.selector.campaign)
        return this.$store.state.selector.campaign;
    }
  },
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/FieldsCarrefour.vue